import { Skeleton } from '@chakra-ui/react';
import GabInformations from '@Modules/terminalManagementSystem/gabManagement/components/GabInformations';
import { createColumnHelper } from '@tanstack/react-table';

export type TGroupMonitoring = {
  primaryKey: string | number,
  group: string,
  inService: {
    num: number,
    state: boolean
  },
  outOfService: {
    num: number,
    state: boolean
  },
  offline: {
    num: number,
    state: boolean
  },
  supervised: {
    num: number,
    state: boolean
  },
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TGroupMonitoring>();

export function getGroupMonitoringDataTableColumns({
  isLoading,
}: Props) {
  return [
    columnHelper.accessor('group', {
      id: 'group',
      header: 'Groupe',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('inService', {
      id: 'inService',
      header: 'En Service',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}><GabInformations numberOfGAB={props.getValue()?.num} status={!!props.getValue()?.state} /></Skeleton>;
      },
    }),

    columnHelper.accessor('outOfService', {
      id: 'outOfService',
      header: 'Hors Serv.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}><GabInformations numberOfGAB={props.getValue()?.num} status={!!props.getValue()?.state} /></Skeleton>;
      },
    }),
    
    columnHelper.accessor('offline', {
      id: 'offline',
      header: 'Non Conn.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}><GabInformations numberOfGAB={props.getValue()?.num} status={!!props.getValue()?.state} /></Skeleton>;
      },
    }),
    
    columnHelper.accessor('supervised', {
      id: 'supervised',
      header: 'Supervis.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{}<GabInformations numberOfGAB={props.getValue()?.num} status={!!props.getValue()?.state} /></Skeleton>;
      },
    }),
    
  ];
}
